import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { MenuComponent } from './menu/menu.component';
import { RodapeComponent } from './rodape/rodape.component';
import { IndicadoresComponent } from './components/indicadores/indicadores.component';
import { DOCUMENT } from '@angular/common';
import { filter } from 'rxjs/internal/operators/filter';
import { environment } from '../environments/environment';

declare let gtag: Function;

@Component({
   selector: 'app-root',
   standalone: true,
   imports: [RouterOutlet, MenuComponent, RodapeComponent, IndicadoresComponent],
   templateUrl: './app.component.html',
   styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
   constructor(@Inject(DOCUMENT) private dom, private activatedRoute: ActivatedRoute, public router: Router) {
      this.trackPageViews();
   }

   ngOnInit() {
      this.createAppSorteosScript();
      this.loadTawkTo();
      const hostName = 'https://cancianimoveis.com.br';

      this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
         var rt = this.getChild(this.activatedRoute);

         rt.data.subscribe((data) => {
            //Set Canonical URL
            if (data.canonical) {
               this.updateCanonicalUrl(hostName + data.canonical);
            } else {
               this.updateCanonicalUrl(hostName + this.router.url);
            }
            //You can set the Meta & Title here
         });
      });
   }

   private createAppSorteosScript() {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = 'https://app-sorteos.com/embed/embed.js';
      script.setAttribute('data-promotion', environment.appSorteosKey);
      script.async = true;
      document.head.appendChild(script);
   }

   private trackPageViews() {
      this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
         gtag('config', 'G-22SKC2JRSW', {
            page_path: event.urlAfterRedirects
         });
      });
   }
   loadTawkTo() {
      // Verifica se o script já está carregado para evitar múltiplos carregamentos
      if (document.getElementById('tawk-script')) {
         console.log('Tawk.to já carregado.');
         return;
      }

      var script = document.createElement('script');
      script.id = 'tawk-script'; // Define um ID para evitar múltiplas inserções
      script.async = true;
      script.src = 'https://embed.tawk.to/59ad9f3cc28eca75e461e135/default';
      script.charset = 'UTF-8';
      script.setAttribute('crossorigin', '*');

      script.onload = () => {
         console.log('Tawk.to carregado!');
         (window as any).Tawk_API = (window as any).Tawk_API || {};
      };

      document.head.appendChild(script);
   }

   getChild(activatedRoute: ActivatedRoute) {
      if (activatedRoute.firstChild) {
         return this.getChild(activatedRoute.firstChild);
      } else {
         return activatedRoute;
      }
   }

   updateCanonicalUrl(url: string) {
      const head = this.dom.getElementsByTagName('head')[0];
      var element: HTMLLinkElement = this.dom.querySelector(`link[rel='canonical']`) || null;
      if (element == null) {
         element = this.dom.createElement('link') as HTMLLinkElement;
         head.appendChild(element);
      }
      element.setAttribute('rel', 'canonical');
      element.setAttribute('href', url);
   }
}
